import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum ReferenceSetTypeId {
  TOP = 'top',
  OTHER = 'other',
}

export class ReferenceSetType extends Codebook<ReferenceSetTypeId> {
  static readonly TOP = new ReferenceSetType(ReferenceSetTypeId.TOP, () => $t('Top'))
  static readonly OTHER = new ReferenceSetType(ReferenceSetTypeId.OTHER, () => $t('Other'))

  private constructor(
    id: ReferenceSetTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }

  public isTop(): boolean {
    return this.id === ReferenceSetTypeId.TOP
  }

  public isOther(): boolean {
    return this.id === ReferenceSetTypeId.OTHER
  }

  public size(): number {
    return this.isTop() ? 3 : 12
  }

  public color(): Color.INFO | Color.GREY_600 {
    return this.isTop() ? Color.INFO : Color.GREY_600
  }
}
